
import React, { useContext, useEffect, useState } from "react";



import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";



function IncreaseCapitalLLP() {
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);

  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };

  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_city: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);
  // if (loading) {
  //   return <div>Loading...</div>;  // Show loading state while fetching data
  // }

  // if (error) {
  //    return <div>{error}</div> // Show error state if there was an issue fetching data
  // }
  const service = Array.isArray(services) ? services.find(s => s.service_id === 45) : null;

  const validateForm = () => {
    const newErrors = {};

    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }


    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };




  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();

    // ✅ Check if user is logged in
    // if (!token) {
    //   alert("Please log in to continue.");
    //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //   navigate('/login'); // 👈 Use this if you're using React Router
    //   return;
    // }
    if (!validateForm()) return;

   localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

  };




  const faqList = [
    {
      question: "What is the process to increase capital in an LLP?",
      answer: "The process involves passing a resolution among partners, drafting the necessary documents, and filing Form 3 and Form 4 with the Registrar of Companies (RoC)."
    },
    {
      question: "Is it mandatory to update the LLP Agreement after capital increase?",
      answer: "Yes, the LLP Agreement must be amended to reflect the revised capital contribution and filed with the RoC."
    },
    {
      question: "How long does the capital increase process take?",
      answer: "It usually takes 7 to 15 working days, depending on document preparation and RoC approval timelines."
    },
    {
      question: "Do we need to pay additional stamp duty on the revised LLP agreement?",
      answer: "Yes, stamp duty is applicable on the increased capital amount as per the respective state laws."
    },
    {
      question: "Can only one partner increase their capital contribution?",
      answer: "Yes, one or more partners can increase their contribution, depending on what is agreed upon in the LLP resolution."
    },
    {
      question: "Does increasing capital affect profit-sharing ratios?",
      answer: "It can, if the LLP Agreement links profit-sharing to capital contribution. In such cases, the ratios may need to be revised."
    },
    {
      question: "Can capital be increased without bringing in new partners?",
      answer: "Yes, existing partners can contribute more capital without introducing new partners."
    },
    {
      question: "What forms are required to be filed for increasing LLP capital?",
      answer: "Primarily, Form 3 (to update the LLP Agreement) and Form 4 (if there's a change in partner contribution or details)."
    },
    {
      question: "Is the increased capital reflected in public records?",
      answer: "Yes, once filed and approved, the updated capital is reflected in the MCA records accessible to the public."
    },
    {
      question: "Why should we increase the capital in an LLP?",
      answer: "To support business growth, attract funding, enhance creditworthiness, and meet new financial commitments."
    }
  ];









  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>

                <h1 className="sk-text-color">Increase Capital (LLP)</h1>

                <p className="pdrl-text">Get Increase Capital (LLP) for only <span className="text-color">Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                <p className="pd-text">Strengthen your financial position, open doors to further funding opportunities, and pave the way for exponential growth. Experience the DM2Legal  advantage and take your company to new heights today.

                </p>

                <div className="banner">
                  <img src="assets/icons/banner.svg" alt="" srcset="" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now</h3>         <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Final Price, No Hidden Costs)</span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">


            <div className="col-lg-12">

              {/* <h2>Annual Compliance LLP </h2> */}


              <p className="pd-text">Increasing the capital in a Limited Liability Partnership (LLP) is a strategic decision that allows your business to grow, meet expanding operational needs, and improve financial strength. Whether you require additional funds to invest in new projects, enhance your working capital, or onboard new partners, increasing your LLP’s capital ensures you have the necessary resources to thrive in a competitive market.

This process involves legally amending your LLP agreement and notifying the Ministry of Corporate Affairs (MCA) about the change. It is essential to follow the regulatory framework set out under the Limited Liability Partnership Act, 2008 to ensure that the capital increase is valid, transparent, and compliant.

Our service guides you through every step — from document preparation to filing the required forms with the MCA, ensuring all procedural formalities are handled accurately and efficiently. We understand the importance of timely completion and legal accuracy to avoid any potential complications in the future.

Partner with us to seamlessly increase your LLP’s capital, strengthen your business foundation, and pave the way for greater opportunities. With our expert guidance, you can focus on growing your business while we take care of the legal and procedural aspects.</p>
            </div>

          </div>


        </div>
      </div>



      <div className="service-binifits9 bg-white" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/new/Increase-Capital-(LLP).png" />
              </div>
              <div className="space20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="space20 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate text-center">Benefits </h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon1.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Enhance Financial Strength</a></h4>
                  <p className="font-f-7">A higher capital base boosts business credibility and financial stability.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon2.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Attract More Investors</a></h4>
                  <p className="font-f-7">Showcase your LLP's growth potential to attract funding and partnerships.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon3.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Meet Regulatory Requirements</a></h4>
                  <p className="font-f-7">Ensure compliance when additional capital is mandated by contracts or regulations.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon4.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Support Expansion Plans</a></h4>
                  <p className="font-f-7">Raise funds internally to fuel your LLP's business development initiatives.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon5.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Improve Market Image</a></h4>
                  <p className="font-f-7">A well-capitalized LLP is seen as more professional and reliable by clients and partners.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon6.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Increase Borrowing Capacity</a></h4>
                  <p className="font-f-7">Banks and financial institutions prefer LLPs with a strong capital base.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon7.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Flexibility for Future Growth</a></h4>
                  <p className="font-f-7">Having more capital opens doors for strategic decisions and business scaling.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon8.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Legal Transparency</a></h4>
                  <p className="font-f-7">Accurate capital records help maintain legal clarity and reduce disputes.</p>
                </div>
              </div>
            </div>
          </div>





          <div className="space20"></div>
        </div>
      </div>

      <div className="service-binifits9 sp0" id="service2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2>Online Registration Procedure </h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li>
                    <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Submit all required documents related to your LLP and capital increase, including the existing LLP agreement and identity proofs of partners.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Our experts draft the necessary amendment or agreement detailing the increase in capital as per LLP Act requirements.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>We prepare and file the prescribed forms (e.g., Form LLP-3) with the Ministry of Corporate Affairs to notify the increase in capital.

                    </span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>The Registrar of Companies reviews the submitted documents and filings for compliance and approves the capital increase.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>Once approved, the updated LLP incorporation certificate reflecting the increased capital is issued and shared with you.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="bg-white">

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                    <div className="space30"></div>
                    <div id="general">


                      {faqList.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      < WhatsAppScrollButton />

      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default IncreaseCapitalLLP;

